import React, { Suspense } from 'react';
import { Route } from 'react-router-dom'
import ReactDOM from 'react-dom';
import PreLoader from '../components/elements/PreLoader';
import store from '../index';
import PopupEnum from '../components/base/PopupEnum';

/* Popup Layout */
const PopupLayout = ({ children, ...rest }) => {
  return (
    ReactDOM.createPortal(
      rest.showFullScreen ? getContent({ children, ...rest }) : <div className={`tb--modal-lvl1 ${rest.popupVisible === PopupEnum.RegistartionFormSuccess ? 'tb--modal-registrationsuccess' : ''}`} >
        <div className='tb--modal-lvl2'>
          <div className='tb--modal-lvl3 tb--rel'>
            {getContent({ children, ...rest })}
          </div>
        </div>
      </div>,
      document.getElementById('modal-root'))
  )
}

/* Popup Layout */
const getContent = ({ children, ...rest }) => {
  return rest.isSettingsLoading ? <PreLoader spinning={rest.isSettingsLoading}>
    <div style={{ height: '100%', width: '100%' }}></div>
  </PreLoader> : children
}

/*
  Private route wrapper
 */

export const PopupRoute = ({ component: Component, isSettingsLoading, ...rest }) => {
  return (
    <Route {...rest} render={matchProps => {
      const { popupVisible, isMyProfilePopupVisible } = store.getState().ui;
      const isPopupVisible = (popupVisible || isMyProfilePopupVisible) && !rest.disabled;
      return (
        isPopupVisible && rest.language ? <PopupLayout popupVisible={popupVisible} key={rest.language} isSettingsLoading={isSettingsLoading} showFullScreen={popupVisible === PopupEnum.Ad}>
          <Suspense fallback={<PreLoader spinning={rest.isSettingsLoading}>
            <div style={{ height: '100%', width: '100%' }}></div>
          </PreLoader>}>
            <Component {...matchProps} />
          </Suspense>
        </PopupLayout> : null
      )
    }} />
  )
};

